<template>
  <main role="main" class="py-4">
    <b-container fluid="xxl"  class="export-area">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">Dashboard</h4>
        <div>
          <b-button variant="outline-secondary" @click="debounceonClickReloadBtn()
          ">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button>
        </div>
      </div>

      <div class="py-5 text-center" v-if="isLoadingOverviewData">
        <b-spinner />
      </div>
      <b-row v-if="!isLoadingOverviewData && overviewData" class="mb-5">
        <b-col v-if="isCustomer()" cols="6" lg="3" class="p-2">
          <div class="text-center rounded py-3" :style="{ 'background-color': '#D7F0F7' }">
            <div><label>{{ $t('subPlanName') }}</label></div>
            <div><strong style="font-size: 1.25rem">{{ activeSubscriptionPlan.name }}</strong></div>
          </div>
        </b-col>
        <b-col v-if="isCustomer()" cols="6" lg="3" class="p-2">
          <div class="text-center rounded py-3" :style="{ 'background-color': '#D7F0F7' }">
            <div><label>{{ $t('expDate') }}</label></div>
            <div><strong style="font-size: 1.25rem">{{ localDateFormat(activeCustomerSubscription.endTime) }}</strong>
            </div>
          </div>
        </b-col>
        <b-col v-for="overviewItem in overviewItems" :key="overviewItem.key" cols="6" lg="3" class="p-2">
          <div class="text-center rounded py-3" :style="{ 'background-color': overviewItem.bgColor }">
            <div><label>{{ overviewItem.text }}</label></div>
            <div><strong style="font-size: 1.25rem">{{ overviewItem.value }}</strong></div>
          </div>
        </b-col>
      </b-row>

      <div class="py-5 text-center" v-if="isLoadingMeetingParticipantsCountData">
        <b-spinner />
      </div>
      <template v-if="!isLoadingMeetingParticipantsCountData && meetingParticipantsCountData">
        <div class="border pt-4 pb-2 mb-5 d-flex flex-column align-items-center" style="height: 600px;">
          <h5 class="mb-3">{{ $t("dashboardChartTitle") }}</h5>
          <b-form class="d-flex flex-row align-items-center" style="width: 600px;"
            @submit.prevent="debounceonClickApplyChartDates()">
            <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
              <div class="flex-shrink-0 mr-3">{{ $t("fromDate") }}</div>
              <b-form-datepicker v-model="chartFilterStartDate" value-as-date required no-flip
                hide-header size="sm" label-no-date-selected="DD/MM/YYYY" locale="vi"
                :max="getMaxDate()"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                start-weekday="1"></b-form-datepicker>
            </div>
            <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
              <div class="flex-shrink-0 mr-3">{{ $t("toDate") }}</div>
              <b-form-datepicker v-model="chartFilterEndDate" value-as-date required no-flip
                hide-header size="sm" label-no-date-selected="DD/MM/YYYY" locale="vi"
                :min="getMinDate(chartFilterStartDate)"
                :max="getMaxDate()"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                start-weekday="1"></b-form-datepicker>
            </div>
            <div>
              <b-button type="submit" variant="primary" size="sm">{{ $t("apply") }}</b-button>
            </div>
          </b-form>
          <div class="text-danger">{{ chartFilterFormErrorMsg }}</div>
          <v-chart class="chart" :option="chartOptions" />
        </div>
      </template>
      <div>
        <div class="d-flex flex-row align-items-center mb-3">
          <div class="flex-shrink-0 mr-4">
            <h5 class="m-0 text-nowrap">{{ $t("meetingList") }}</h5>
          </div>
          <b-form class="d-flex align-items-center flex-grow-1" @submit.prevent="onSubmitSearch"
            style="justify-content: flex-start;">
            <b-form-input
              style="width: 240px; font-family:'Source Sans Pro', sans-serif; height: calc(1rem - 1px + 0.75rem + 2px) !important;padding-left: 1rem !important;"
              class="mr-3 d-flex flex-row flex-shrink-0" type="search" minlength="2" maxlength="200" v-model="searchText"
              :placeholder="$t('keywordMeetings')" />
            <b-form-select v-model="filterStatus" :options="filterStatusOptions" class="mr-3 d-flex flex-shrink-0"
              style="width: 150px; font-family: 'Source Sans Pro', sans-serif;height: calc(1rem - 1px + 0.75rem + 2px) !important;padding: 0 0 0 1rem !important;" />
            <!-- hiển thị dạng DD/MM/YYYY ở cả 2 ô ngày -->
            <div class="flex-grow-1 d-flex flex-row align-items-center mr-3" style="min-width: 175px;">
              <div class="flex-shrink-0 mr-2">{{ $t("fromDate") }}</div>
              <b-form-datepicker v-model="startDate" 
                value-as-date 
                :max="getMaxDate()" no-flip hide-header
                size="sm"
                label-no-date-selected="DD/MM/YYYY"
                locale="vi" 
                class="text-nowrap flex-grow-1"
                style="min-width: 125px;"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                start-weekday="1"></b-form-datepicker>
            </div>
            <div class="flex-grow-1 d-flex flex-row align-items-center mr-3" style="min-width: 175px;">
              <div class="flex-shrink-0 mr-2">{{ $t("toDate") }}</div>
              <b-form-datepicker v-model="endDate" value-as-date no-flip hide-header
                size="sm"
                label-no-date-selected="DD/MM/YYYY"
                locale="vi" 
                class="text-nowrap flex-grow-1"
                style="min-width: 125px;"
                :min="getMinDate(startDate)"
                :max="getMaxDate()"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                start-weekday="1"></b-form-datepicker>
            </div>
            <div class="flex-shrink-0">
              <b-button type="submit" variant="primary" size="sm">{{ $t("search") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>
      <b-table :items="meetingsToday" :busy="isLoadingMeetingsToday" :fields="tableFields" primary-key="id" hover
        show-empty>
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(id)="data">
          <!-- <router-link v-if="data.item.owner || isUserAdmin() || data.item.canView" :to="`/meetings/details/${data.item.id}`"> -->
          <router-link v-if="data.item.isDeleted === 0 && !isManager()" target="_blank" :to="`/meetings/details/${data.item.id}`"
            class="underline">
            {{ data.item.id }}
          </router-link>
          <span v-else> {{ data.item.id }}</span>
          <!-- <span v-else>{{ data.item.id }}</span> -->
        </template>
        <template v-slot:cell(name)="data">
          <div style="max-width: 60vh; white-space: normal; word-break: break-word;">
            <span>
              {{ data.item.name }}
            </span>
          </div>
          <Badge
            v-if="isUserAdmin() && data.item.status !== enumMeetingStatus.PENDING"
            :domain="data.item.coreDomain"
            class="mr-2"
          />
          <Badge :meeting="data.item" />
        </template>

        <template v-slot:cell(createdDate)="data">
          {{ data.item.createdAt }}
          <br>
        </template>
        <template v-slot:cell(meetingDate)="data">
          {{ data.item.startTime }}
          <br>
        </template>
        <template v-slot:cell(datetime)="data">
          {{ data.item.meetingTime }}<br />
          <span v-if="data.item.actualParticipantCount > 0" style="font-size: 14px;">
            {{ $t("joinMeeting") }}: {{ data.item.actualParticipantCount }}
          </span>
        </template>
        <!--Thời lượng-->
        <template v-slot:cell(duration)="data">
          {{ convertDuration(data.item.duration) }}
        </template>
        <template v-slot:cell(customer)="data">
          <div style="max-width: 20vh; white-space: normal; word-break: break-word;">
            <router-link v-if="data.item.customerIsDeleted === 0" target="_blank"
              :to="`/customers/details/${data.item.customerId}`" class="underline">
              {{ data.item.customerName }} ({{ data.item.customerId }})
            </router-link>
            <span v-else>{{ data.item.customerName }} ({{ data.item.customerId }})</span>
          </div>
        </template>
        <template v-slot:cell(createdBy)="data">
          <div style="max-width: 20vh; white-space: normal; word-break: break-word;">
            <span v-if="data.item.createdByName">
              {{ data.item.createdByUsername }} ({{ data.item.createdById }})
            </span>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <b-badge :variant="meetingStatusBadgeVariant[data.item.status]">{{ meetingStatusText[data.item.status]
          }}</b-badge>
        </template>
        <template v-slot:cell(isDeleted)="data">

          <span v-if="data.item.isDeletedStr">
            {{ (data.item.isDeletedStr) }} ({{ data.item.deletedById }})
          </span>

        </template>
        <template v-slot:cell(actions)="data">
          <div v-if="showMontorButton(data.item)">
            <b-button variant="link" size="sm" :to="`/monitor-meeting/${data.item.id}`" v-b-tooltip.hover
              :title="$t('viewStats')">
              <b-icon-graph-up></b-icon-graph-up>
            </b-button>
          </div>
        </template>
        <template #cell(isDeleteBy)="data">
          <div style="max-width: 20vh; white-space: normal; word-break: break-word;">
            <span v-if="data.item.deletedById">
              {{ data.item.deletedByUsername }} ({{ data.item.deletedById }})
            </span>
          </div>
        </template>

      </b-table>
      <div class="d-flex flex-row no-export" v-if="meetingsToday && totalItems > 0">
        <b-button class="mr-4" variant="outline-primary" @click="onClickDownloadBtn" style="text-wrap-mode: nowrap;">
          <b-icon icon="download" class="mr-2"></b-icon> {{ $t("export") }}
        </b-button>
        <div class="d-flex flex-row align-items-center " style="justify-content: flex-end; width: 100%;">
          <div style="overflow-x: auto; width: 100%;">
            <div class="d-flex flex-row align-items-center" style="min-width: 300px;justify-self: end;">
              <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">
                {{ $t("resultCount", { count: totalItems }) }}
              </div>
              <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"
                @input="onPageChange"></b-pagination>
              <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections" style="width: 35%;"
                @change="fetchMeetingsToday({ currentPage, perPage: itemsPerPage })"></b-form-select>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>
.underline {
  color: #004f9e;
  display: inline-block;
  //border-bottom: 1px solid #004f9e; 
}
::v-deep .b-form-datepicker label {
  white-space: nowrap !important;
}
</style>

<script lang="ts">
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import _ from "lodash";
import moment from "moment";

import * as util from "@/service/util";
import BaseComponent from "@/components/BaseComponent";

import * as reportService from "@/service/reportService";
import { BTable, BvTableFieldArray } from "bootstrap-vue";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import { convertMeetingName2FileName } from "@/service/util";

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { BounceTimes } from './enums/TimesNumbers';
import * as exportService from "@/service/exportService";
import { MeetingStatus } from './enums/MeetingStatus';
import Badge from '@/components/helpers/Badge.vue';
import { SearchRequestManager } from "@/utils/search-request-manager";

@Component({
  components: { Badge }
})
export default class Dashboard extends BaseComponent {

 enumMeetingStatus = MeetingStatus;

  isLoadingOverviewData = false;
  overviewData = null;
  activeCustomerSubscription = null;
  activeSubscriptionPlan = null;

  overviewItems = [
    { text: this.$t("totalCustomers").toString(), key: "totalCustomers", value: "--", bgColor: "#D7F0F7" },
    { text: this.$t("totalPackages").toString(), key: "totalPackages", value: "--", bgColor: "#D7F0F7" },
    { text: this.$t("totalMeetings").toString(), key: "totalMeetings", value: "--", bgColor: "#D7F0F7" },
    { text: this.$t("totalCustomerAccounts").toString(), key: "totalCustomerAccounts", value: "--", bgColor: "#D7F0F7" },
    { text: this.$t("totalInprogressMeetings").toString(), key: "totalInprogressMeetings", value: "--", bgColor: "#F0FBCD" },
    { text: this.$t("totalPendingMeetings").toString(), key: "totalPendingMeetings", value: "--", bgColor: "#81FF81" },
    { text: this.$t("totalEndedMeetings").toString(), key: "totalEndedMeetings", value: "--", bgColor: "#C3C3C3" },
    { text: this.$t("totalCancelledMeetings").toString(), key: "totalCancelledMeetings", value: "--", bgColor: "#FEAEC9" },
  ];

  isLoadingMeetingParticipantsCountData = false;
  meetingParticipantsCountData = null;

  chartOptions = {
    legend: {
      top: 36,
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      data: [],
    },
    yAxis: [
      {
        type: 'value',
        name: this.$t("meeting").toString(),
        position: 'left',
        nameTextStyle: {
          fontWeight: "bold"
        }
      },
      {
        type: 'value',
        name: this.$t("meetingParticipant").toString(),
        position: 'right',
        nameTextStyle: {
          fontWeight: "bold"
        }
      },
    ],
    grid: {
      top: 100,
    },
    series: [
      {
        name: this.$t("meeting").toString(),
        type: 'bar',
        yAxisIndex: 0,
        data: []
      },
      {
        name: this.$t("meetingParticipant").toString(),
        type: 'bar',
        yAxisIndex: 1,
        data: []
      },
      {
        name: this.$t("numCameraOn").toString(),
        type: 'line',
        data: []
      },
    ]
  };
  chartFilterStartDate: Date = null;
  chartFilterEndDate: Date = null;
  chartFilterFormErrorMsg = "";

  todayText = "";
  readonly meetingStatusText = {
    PENDING: this.$t("meetingStatusPending").toString(),
    INPROGRESS: this.$t("meetingStatusInProgress").toString(),
    END: this.$t("meetingStatusEnded").toString(),
    CANCEL: this.$t("meetingStatusCancelled").toString(),
  };
  readonly meetingStatusBadgeVariant = {
    PENDING: "warning",
    INPROGRESS: "success",
    END: "secondary",
    CANCEL: "danger"
  };
  get tableFields(): BvTableFieldArray {
    let fields: any[] = [
      {
        key: "id",
        label: "ID"
      },
      {
        key: "name",
        label: this.$t("meetingName").toString(),
        thClass: "text-nowrap",
      },

      {
        key: "createdDate",
        label: this.$t("createdDate").toString()
      },
      {
        key: "meetingDate",
        label: this.$t("meetingDate").toString()
      },
      {
        key: "datetime",
        label: this.$t("datetime").toString(),
        thClass: "text-nowrap",
        tdClass: "text-nowrap"
      },
      {
        key: "duration",
        label: this.$t("meetingDuration").toString(),
        thClass: "text-nowrap",
        tdClass: "text-nowrap"
      },
    ];

    if (this.isUserAdmin() || this.isManager() || this.isUserSuperAdmin()) {
      fields.splice(6, 0, {
        key: "customer",
        label: this.$t("customer").toString(),
      });
    }

    if (this.isCustomer()) {
      fields.splice(6, 0, {
        key: "createdBy",
        label: this.$t("createBy").toString(),
        thClass: "text-nowrap",
      });
      if (this.appliedFilterStatus === 'DELETE') {
        fields.splice(7, 0, {
          key: "isDeleteBy",
          label: this.$t("deleteBy").toString(),
          thClass: "text-nowrap",
        });
      }
    }

    fields.push({
      key: "status",
      label: this.$t("status").toString(),
      thClass: "text-nowrap",
      tdClass: "text-nowrap"
    });

    fields.push({
      key: "actions",
      label: "",
      thClass: "text-nowrap",
      tdClass: "text-nowrap"
    });

    if (this.isUserAdmin() || this.isManager() || this.isUserSuperAdmin()) {
      fields.push({
        key: "isDeleted",
        label: ''
      });
    }

    return fields;
  }
  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];
  itemsPerPage = 20;
  currentPage = 1;
  totalItems = 0;

  isLoadingMeetingsToday = false;
  meetingsToday = null;
  searchManager = new SearchRequestManager();

  startDate: Date = null;
  endDate: Date = null;

  fromDateFile: string = null;
  toDateFile: string = null;
  searchText = "";
  filterStatus: string = MeetingStatus.INPROGRESS;
  appliedFilterStatus: string = MeetingStatus.INPROGRESS;
  raw_csv_data: string = '';
  res_data = [];
  res = [];
  requestParams={};
  readonly filterStatusOptions = [
    { value: null, text: this.$t("all").toString() },
    { value: "PENDING", text: this.$t("meetingStatusPending").toString() },
    { value: "INPROGRESS", text: this.$t("meetingStatusInProgress").toString() },
    { value: "END", text: this.$t("meetingStatusEnded").toString() },
    { value: "CANCEL", text: this.$t("meetingStatusCancelled").toString() },
    { value: "DELETE", text: this.$t("deleted").toString() },
  ];

  readonly statusBadgeVariant = {
    PENDING: "warning",
    INPROGRESS: "success",
    END: "secondary",
    CANCEL: "danger"
  };

  results = [];

  @Ref("table") table: BTable;

  mounted() {
    
    this.chartFilterStartDate = moment().subtract(30, "days").startOf("day").toDate();
    this.chartFilterEndDate = moment().endOf("day").toDate();

    this.fetchOverview();
    this.fetchMeetingParticipantsCountData();
    this.fetchMeetingsToday();

    if (this.isCustomer()) {
      this.overviewItems.shift();
      this.overviewItems.shift();
    }

  }

  @Watch("overviewData", { immediate: true, deep: true })
  onOverviewDataChange(overviewData) {
    for (const overviewItem of this.overviewItems) {
      overviewItem.value = overviewData?.[overviewItem.key] || "--";
    }
  }

  @Watch("meetingParticipantsCountData", { immediate: true, deep: true })
  onMeetingParticipantsCountDataChange(meetingParticipantsCountData) {
    if (meetingParticipantsCountData) {
      this.chartOptions.xAxis.data = meetingParticipantsCountData.map(it => it.scheduleDate);
      this.chartOptions.series[0].data = meetingParticipantsCountData.map(it => it.totalMeetings);
      this.chartOptions.series[1].data = meetingParticipantsCountData.map(it => it.totalParticipants);
      this.chartOptions.series[2].data = meetingParticipantsCountData.map(it => it.totalCameras);
    }
  }

  async fetchOverview() {
    try {
      this.isLoadingOverviewData = true;
      this.overviewData = await reportService.getDashboardOverview();
      if (this.isCustomer()) {
        const customerSubscriptions = await subscriptionPlanService.getCustomerSubscription(this.user.customerId);
        this.activeCustomerSubscription = customerSubscriptions.find(it => it.isActive);

        if (this.activeCustomerSubscription) {
          const { subscriptionPlanId } = this.activeCustomerSubscription;
          this.activeSubscriptionPlan = await subscriptionPlanService.getPackageDetail(subscriptionPlanId);
        }
      }
    } catch (e) {
      this.toastError(e);

    } finally {
      this.isLoadingOverviewData = false;
    }
  }

  async fetchMeetingParticipantsCountData() {
    this.chartFilterFormErrorMsg = "";

    if (this.chartFilterStartDate.getTime() > this.chartFilterEndDate.getTime()) {
      this.chartFilterFormErrorMsg = this.$t("invalidDateRange").toString();
      return;
    }

    let startDate = new Date(this.chartFilterStartDate);
    let endDate = new Date(this.chartFilterEndDate);

    startDate.setUTCHours(0, 0, 0, 0);
    endDate.setUTCHours(0, 0, 0, 0);

    // Cộng thêm 1 ngày
    startDate.setDate(startDate.getDate() + 1);
    // Cộng thêm 2 ngày (tìm kiếm ngày 23 thì sẽ lấy ngày 24(00:00:00))
    endDate.setDate(endDate.getDate() + 2);

    const fromDate = startDate.toISOString();
    const toDate = endDate.toISOString();

    try {
      this.isLoadingMeetingParticipantsCountData = true;
      this.meetingParticipantsCountData = await reportService.getMeetingParticipants(fromDate, toDate);
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isLoadingMeetingParticipantsCountData = false;
    }
  }

  debouncefetchMeetingsToday = _.debounce(() => {
    this.fetchMeetingsToday ();
  }, BounceTimes.BOUNCETIMES);

  onSubmitSearch() {
    this.searchManager.onSubmit({
      debounceFn: this.debouncefetchMeetingsToday,
      resetPage: () => { this.currentPage = 1; },
      execute: () => { this.fetchMeetingsToday(); }
    });
  }

  async fetchMeetingsToday(ctx = null) {    
    this.isLoadingMeetingsToday = true;
    const currentRequestId = this.searchManager.nextId();
  //đưa các xử lý về ngày tháng vào đây
    this.todayText = moment().format("YYYY-MM-DD");
    let startDateString = "";
    if(this.startDate != null){
      const startDate = new Date(this.startDate);
      startDate.setDate(startDate.getDate() + 1);
      startDate.setUTCHours(0, 0, 0, 0);
      startDateString = startDate.toISOString();
    }        
    let endDateString = "";
    if (this.endDate) {
      const currentEndDate = new Date(this.endDate);
      currentEndDate.setDate(currentEndDate.getDate() + 2);
      currentEndDate.setUTCHours(0, 0, 0, 0);
      endDateString = currentEndDate.toISOString();
    }

     ///xuất excel nhận được giá trị ngày tháng
    this.fromDateFile = startDateString;
    this.toDateFile = endDateString;
    ///
    let page = this.currentPage;
    let pageSize = this.itemsPerPage;

    const requestParams: any = {
      q: this.searchText?.trim(),
      status: this.filterStatus === this.enumMeetingStatus.DELETE ? null : this.filterStatus,
      isDeleted: this.filterStatus === this.enumMeetingStatus.PENDING  ? 0 : (this.filterStatus === this.enumMeetingStatus.DELETE ? 1 : undefined),
      fromDate: startDateString,
      toDate: endDateString,
      page,
      pageSize,
    };
    this.requestParams = requestParams;
    this.appliedFilterStatus = this.filterStatus;
    //api danh sách cuộc họp
    try {
      const res = await reportService.getMeetingListDashboard(this.requestParams);
      if (!this.searchManager.isLatest(currentRequestId)) {
        return;
      }
      this.totalItems = res.total;
      this.meetingsToday = res.data;
    } catch (e) {
      if (this.searchManager.isLatest(currentRequestId)) {
        this.toastErrorOldType(e);
      }
    } finally {
      if (this.searchManager.isLatest(currentRequestId)) {
        this.isLoadingMeetingsToday = false;
      }
    }
  }

async  onClickDownloadBtn() {
  try {
    // Lấy dữ liệu từ service
    const rawData = await reportService.getMeetingListDashboard_ExportExcel(this.requestParams);

    let data;
    
    // Case 1 : raw is CSV
    if (typeof rawData === 'string') {
      data = this.parseCSV(rawData);
    } 
    // Case 2 : raw is array
    else if (Array.isArray(rawData)) {
      data = rawData;
    } 
    //Cass 3 : object array
    else if (rawData && rawData.data && Array.isArray(rawData.data)) {
      data = rawData.data;
    } 
    // Case 4: #
    else if (rawData && typeof rawData === 'object') {
      // Tìm thuộc tính đầu tiên là mảng
      const arrayKey = Object.keys(rawData).find(key => Array.isArray(rawData[key]));
      if (arrayKey) {
        data = rawData[arrayKey];
      } else {
        throw new Error('Không tìm thấy dữ liệu mảng trong response');
      }
    } else {
      throw new Error('Dữ liệu trả về không đúng định dạng');
    }
    
    // Kiểm tra dữ liệu có phải mảng không
    if (!Array.isArray(data)) {
      throw new Error('Dữ liệu không phải là mảng');
    }
    // Xử lý từng dòng dữ liệu
    data = data.map(item => {
      // Tạo bản sao để không thay đổi dữ liệu gốc
      const newItem = { ...item };
      
      // Dịch cột Trạng thái (nếu có)
      if (newItem['Trạng thái'] && this.$t(newItem['Trạng thái'])) {
        newItem['Trạng thái'] = this.$t(newItem['Trạng thái']);
      }
      
      return newItem;
    });
    
    
    // Tạo workbook mới
    const wb = XLSX.utils.book_new();
    
    // Chuyển đổi dữ liệu thành worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    
    // Định dạng header
    const headerRange = XLSX.utils.decode_range(ws['!ref']);
    for (let C = headerRange.s.c; C <= headerRange.e.c; C++) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[headerCell]) continue;
      ws[headerCell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "E0E0E0" } },
        alignment: { horizontal: "center" }
      };
    }
    
    // Định dạng cột STT và Id
    for (let R = 0; R <= headerRange.e.r; R++) {
      const sttCell = XLSX.utils.encode_cell({ r: R, c: 0 });
      const idCell = XLSX.utils.encode_cell({ r: R, c: 1 });
      
      if (ws[sttCell]) {
        ws[sttCell].s = { alignment: { horizontal: "center" } };
      }
      
      if (ws[idCell]) {
        ws[idCell].s = { alignment: { horizontal: "center" } };
      }
    }
    
    // Thêm worksheet vào workbook
    XLSX.utils.book_append_sheet(wb, ws, "Danh sách cuộc họp");
    
    // Tạo file Excel
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    
    // Tạo blob và tải xuống
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const fileName = `Danh_sach_cuoc_hop_${new Date().toISOString().slice(0, 10)}.xlsx`;
    saveAs(blob, fileName);
    
    // Thông báo thành công
    
  } catch (error) {
    console.error('Lỗi khi xuất Excel:', error);
 
  }
}

// Hàm phân tích chuỗi CSV thành mảng đối tượng
parseCSV(csvString) {
  const lines = csvString.split('\n');
  const headers = lines[0].split(',').map(header => header.trim().replace(/"/g, ''));
  
  const result = [];
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;
    
    // Xử lý các giá trị có chứa dấu phẩy trong ngoặc kép
    const values = [];
    let currentValue = '';
    let inQuotes = false;
    
    for (let j = 0; j < line.length; j++) {
      const char = line[j];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        values.push(currentValue.trim().replace(/"/g, ''));
        currentValue = '';
      } else {
        currentValue += char;
      }
    }
    values.push(currentValue.trim().replace(/"/g, ''));
    
    // Tạo đối tượng từ header và values
    const obj = {};
    headers.forEach((header, index) => {
      obj[header] = values[index] || '';
    });
    
    result.push(obj);
  }
  
  return result;
}


  debounceonClickReloadBtn  = _.debounce(() => {
    this.onClickReloadBtn ();
  }, BounceTimes.BOUNCETIMES);
  onClickReloadBtn() {
    this.searchText = "";
    this.filterStatus = MeetingStatus.INPROGRESS;
    this.currentPage = 1;
    this.startDate = null; 
    this.endDate = null;
    if (this.table) {
      this.table.refresh();
    }

    this.fetchOverview();
    this.fetchMeetingParticipantsCountData();
    this.fetchMeetingsToday();
  }

  filteredMeetings() {
    const q = this.searchText.toLowerCase();
    return this.meetingsToday.filter(meeting =>
      meeting.name.toLowerCase().includes(q) ||
      meeting.id.toString().includes(q)
    );
  }
  async onPageChange(newPage) {
    this.currentPage = newPage;
    await this.fetchMeetingsToday({ currentPage: newPage });
  }


    debounceonClickApplyChartDates = _.debounce(() => {
    this.onClickApplyChartDates ();
  }, BounceTimes.BOUNCETIMES);
  onClickApplyChartDates() {
    this.fetchMeetingParticipantsCountData();
  }


  isBBB(meeting): boolean {
    return meeting?.corePlatform?.toLowerCase() === "bbb";
  }

  isZoom(meeting): boolean {
    return meeting?.corePlatform?.toLowerCase() === "zoom";
  }

  getMeetingChatSettingsTooltipText(meeting) {
    return [
      meeting.enablePrivateChat ? this.$t("meetingPrivateChatAllow").toString() : undefined,
      meeting.enablePublicChat ? this.$t("meetingPublicChatAllow").toString() : undefined,
    ].filter(_.identity).join("\n");
  }

  /// Chuyển đổi duration format: xhxpxs -> x:x:x
  convertDuration(duration) {
    const match = duration.match(/^(?:(\d+)h)?(?:(\d+)p)?(?:(\d+)s)?$/);
    if (!match) return duration;
    ///
    const hours = parseInt(match[1] || 0);
    const minutes = parseInt(match[2] || 0);
    const seconds = parseInt(match[3] || 0);
    ///
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  //Điều kiện hiển thị nút monitor
  showMontorButton(item) {
    return item.isDeleted === 0 && (item.status === 'END' || item.status === 'INPROGRESS') && !this.isManager();
  }
  // test function xuất trang thành pdf
  async exportFullPageToPDF() {
  try {
    const { jsPDF } = await import('jspdf');
    const html2canvas = (await import('html2canvas')).default;

    // Ẩn nút export
    const button = document.querySelector('.export-fullpage-btn') as HTMLElement | null;
    if (button) button.style.display = 'none';

    // 🎯 Chỉ chọn vùng trong b-container
    const element = document.querySelector('.export-area') as HTMLElement;
    if (!element) {
      console.error('Không tìm thấy .export-area để xuất PDF');
      if (button) button.style.display = 'block';
      return;
    }

    // Chụp nội dung
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      backgroundColor: '#ffffff', // đảm bảo nền trắng
      ignoreElements: (el) => el.classList.contains('no-export'),
    });

    // Hiện lại nút
    if (button) button.style.display = 'block';

    // Chuyển ảnh sang PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Tự động chia trang nếu dài
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const fileName = `NoiDungChinh_${moment().format('YYYYMMDD_HHmm')}.pdf`;
    pdf.save(fileName);
    } catch (e) {
      console.error(e);
      this.toastErrorOldType(e);
    }
  }

}
</script>
